var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('CJumbotron',{attrs:{"color":"success"}},[_c('h2',[_vm._v("棒棒的，支付成功了。 联系客服进行接入。")]),_c('hr'),_c('CButton',{attrs:{"size":"lg","color":"info","to":{'name':'DomainList'}}},[_vm._v("前往域名管理")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }